import { LinkingOptions } from "@react-navigation/native";

import { RootStackParamList } from "./types";

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [],
  config: {
    screens: {
      AuthenticatedFlow: {
        screens: {
          SelectTenant: "select_tenant",
          AccountSetup: "account_setup",
          MainFlow: {
            screens: {
              Home: {
                screens: {
                  DashboardScreen: "",
                  ActivateAll: "activate_all_vouchers",
                },
              },
              MyEvents: {
                screens: {
                  Events: "event",
                  EventDetail: "events/:groupCode",
                  Barcode: "events/:groupCode/barcodes",
                  Guests: "events/:groupCode/guests",
                },
              },
              Schedule: {
                screens: {
                  ScheduleScreen: "schedule",
                  EventAvailablityDetails: "schedule/event_details",
                  SeatSelection: "seats",
                  Reserve: "reserve",
                  PremiumCodeDetails: "inventory_details",
                },
              },
              Account: {
                screens: {
                  AccountScreen: "account",
                  PaymentMethod: "account/payment_method",
                  EditProfile: "account/edit_profile",
                  Settings: {
                    screens: {
                      SettingScreen: "account/settings",
                    },
                  },
                  UpdateBillingInterval: "account/update_billing",
                  AccountDetails: {
                    screens: {
                      AccountDetailsScreen: "account/details",
                    },
                  },
                  Activity: "account/activity",
                  ManageSubscriptions: {
                    screens: {
                      ManageSubscriptionsScreen: "account/manage_subscriptions",
                      SubscriptionDetail:
                        "account/manage_subscriptions/:memberId",
                      AddNewPlan: "account/manage_subscriptions/:memberId/new",
                      AddNewPlanWithPlanPackageId:
                        "account/manage_subscriptions/:memberId/new/:planPackageId",
                    },
                  },
                  AddMembership: "account/add_membership",
                  MemberCard: "account/member_card",
                  MyGifts: "account/my_gifts",
                },
              },
            },
          },
        },
      },
      LoginFlow: {
        screens: {
          Register: "register/:preSelectedPlanPackageId?",
          Login: "login",
          ForgotPassword: "forgot_password",
          ResetPassword: "reset_password/:encodedEmail",
        },
      },
      ClaimSeats: "claim_seats/:eventCode/:transferCode",
      ClaimGuestPasses: "claim_guest_passes/:eventCode/:transferCode",
      Legal: "legal/:documentName",
      GroupReservation: "group_reservation/:eventCode/:groupCode",
      Shop: "shop/:slug",
      ShopPagePhaseTwo: "new_shop/:slug",
      FinishSignup: "finish_signup/:encodedEmail",
      BallparkAccountNotFound: "ballpark_account_not_found",
      BuyGift: "buy_gift/:planPackageId?",
      ClaimGift: "claim_gift/:code",
    },
  },
};

export default linking;
